<template>
  <div class="row">
    <el-dialog
      left
      :title="title"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      @close="handleCancel()"
      :visible.sync="isShow"
      style="margin: 0 auto;"
      width="650px"
      class="registrar-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div class="row">
        <div class="col-6">
          <div class="row">
            <div class="col-12">
              <div>
                <div>Investment Date</div>
                <input
                  class="form-control team-form"
                  type="date"
                  :max="moment().format('YYYY-MM-DD')"
                  min="2000-01-01"
                  :value="value.data.transaction_date && moment.utc(value.data.transaction_date).format('YYYY-MM-DD')"
                  @input="value.data.transaction_date = moment($event.target.valueAsDate)"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div>
                <div>Offerings</div>
                <template v-if="value.data.offering && value.data.offering.funding_type">
                  <el-select
                    class="todo-dropdown-el-select"
                    size="large"
                    placeholder="Select Offerings"
                    v-model="value.data.offering.funding_type"
                  >
                    <el-option
                      v-for="option in vals.STAGE_DEFINES"
                      class="select-primary"
                      :value="option"
                      :label="option"
                      :key="option"
                    ></el-option>
                  </el-select>
                </template>
                <template v-else>
                  <el-select
                    class="todo-dropdown-el-select"
                    size="large"
                    placeholder="Select Offerings"
                    v-model="value.data.offering"
                  >
                    <el-option
                      v-for="option in vals.STAGE_DEFINES"
                      class="select-primary"
                      :value="option"
                      :label="option"
                      :key="option"
                    ></el-option>
                  </el-select>
                </template>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div>
                <div>Amount</div>
                <input
                  type="number"
                  v-model="value.data.amount"
                  class="form-control team-form"
                  style="width: 100%;"
                  placeholder="Amount in USD"
                  min="1"
                  v-on:change="handleChange()"
                />
              </div>
            </div>
          </div>

          <!-- <div class="row">
            <div class="col-12">
              <div>
                <div>Ownership in %:</div>
                <input
                  type="number"
                  v-model="value.data.ownership_percent"
                  class="form-control"
                  style="width: 100%;"
                  placeholder="Ownsership in %"
                  maxlength="2"
                  min="1"
                  max="99"
                  v-on:change="handleChange()"
                />
              </div>
            </div>
          </div>-->
          <!-- <div class="row">
            <div class="col-12">
              <div>
                <div>Equity in %</div>
                <input
                  type="number"
                  v-model="value.data.equity"
                  class="form-control"
                  style="width: 100%;"
                  placeholder="Equity  in %"
                  @keyup="handleChange()"
                />
              </div>
            </div>
          </div>-->
          <div class="row">
            <div class="col-12">
              <div>
                <div>Equity Standing</div>
                <input
                  type="number"
                  v-model="value.data.equity_standing"
                  class="form-control team-form"
                  style="width: 100%; cursor:pointer"
                  placeholder="Equity Standing in %"
                  @keyup="handleChange()"
                />
                <!-- <small>
                  <a
                    class="link float-right"
                    style="cursor:pointer"
                    :href="contactEmail"
                    v-if="contactEmail"
                  >Verify your equity standing</a>
                </small>-->
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div>
                <div>Notes</div>
                <textarea
                  class="form-control team-form"
                  @keyup="handleChange()"
                  rows="6"
                  cols="50"
                  v-model="value.data.notes"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div>
                <div class="chb">
                  <span>Has Pro-Rata</span>
                  <input
                    type="checkbox"
                    v-model="value.data.is_prorata"
                    class="form-control"
                    style="width: auto;height: auto;margin: 0 0 0 10px;"
                  />
                </div>
              </div>
            </div>
            <div class="col-6">
              <div>
                <div class="chb">
                  <span>Is lead Investor</span>
                  <input
                    type="checkbox"
                    v-model="value.data.is_lead_investor"
                    class="form-control"
                    style="width: auto;height: auto;margin: 0 0 0 10px;"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="row">
            <div class="col-12">
              <div>
                <div>Tag</div>
                <input
                  type="text"
                  v-model="value.data.cohort"
                  class="form-control team-form"
                  style="width: 100%;"
                  placeholder="Enter Tag"
                  @keyup="handleChange()"
                />
              </div>
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-12">
              <div>
                <div>Transaction Type</div>
                <el-select
                  class="select-primary"
                  size="large"
                  placeholder="Transaction Type"
                  v-model="value.data.transaction_type"
                >
                  <el-option
                    v-for="option in vals.TRANSACTION_TYPE"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="option"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>-->
          <div class="row">
            <div class="col-12">
              <div>
                <div>Term</div>
                <el-select
                  class="todo-dropdown-el-select"
                  size="large"
                  placeholder="Term"
                  v-model="value.data.term"
                >
                  <el-option
                    v-for="option in vals.TERMS"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="option"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div>Investement Type</div>
              <el-select
                class="todo-dropdown-el-select"
                size="large"
                placeholder="Investement Type"
                v-model="value.data.investment_type"
                :disabled="investmentDisabled"
              >
                <el-option
                  v-for="option in vals.INVESTMENT_TYPE"
                  class="select-primary"
                  :value="option"
                  :label="option"
                  :key="option"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div>
                <div>Referred By</div>
                <!-- <input
                  type="text"
                  v-model="value.data.referred_by"
                  class="form-control"
                  style="width: 100%;"
                  placeholder="Referred By"
                  @keyup="handleChange()"
                />-->
                <!-- <autocomplete
                  ref="autocomplete"
                  placeholder="Referred by"
                  v-model = value.data.referred_by
                  :resultsFormatter="resultsFormatter"
                  :source="autocompleteAttributorsEndPoint"
                  input-class="select-primary form-control"
                  results-property="data.items"
                  :results-display="formattedDisplay"
                  @selected="onAfterAttributorSelection"
                ></autocomplete>-->
                <vue-bootstrap-typeahead
                  :minMatchingChars="0"
                  :data="referredResults"
                  v-model="referred_by"
                  class="todo-dropdown-el-select"
                  ref="autocomplete"
                  :serializer="s=>s.name"
                  placeholder="Referred by"
                  @hit="saveReferredBy($event)"
                  style="margin-bottom:10px"
                ></vue-bootstrap-typeahead>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div>
                <div style="margin-bottom: .3rem;">
                  Documents
                  <span v-if="files.length">({{files.length}})</span>
                </div>
                <edit-links-card
                  :context="'fileupload'"
                  :links="files"
                  :isModal="false"
                  @edit-links-card-add="linksAdd"
                  @edit-links-card-remove="linksDelete"
                  @edit-links-card-update="linksUpdated"
                  @edit-links-card-download="linksDownload"
                >
                  <!-- <template slot="header">
                  <span v-if="files.length">({{files.length}})</span>
                  </template>-->
                </edit-links-card>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="row"> -->
        <div class="col-12 d-flex">
          <div class="col-xl edit-company-action-button-row" style="padding: 0px">
            <button
              type="button"
              class="todo-form-cancel-button btn-outline-secondary"
              @click.prevent="handleCancel"
            >Cancel</button>
            <button
              type="submit"
              :disabled="isSaving"
              @click.prevent="handleSave"
              class="btn btn-info btn-fill btn-wd"
            >
              Save Investment
              <b-spinner v-if="isSaving" style="float: right;" small label="Loading..."></b-spinner>
            </button>
          </div>
        </div>
        <a class="hidden" ref="hiddenDownloadAnchor" :href="downloadLink">Download Sample</a>
      </div>
    </el-dialog>
    <el-dialog
      center
      width="494px"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      :visible.sync="investmentSubmit"
    >
      <div class="row container">
        <p style="padding-left:1.3rem">
          Would you like us to help you validate your
          <b>Standing</b> in the company?
          <br />We can help you by reaching out to the founders and verifying your investment status. Don't worry, you will be able to edit the email before sending.
        </p>
      </div>
      <div class="row">
        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xs-6" style="padding-left:2rem">
          <a :href="emailString" v-if="emailString" target="_blank">
            <button
              type="button"
              class="btn btn-info btn-fill btn-wd"
              @click="investmentSubmit=!investmentSubmit"
            >Verify now</button>
          </a>
        </div>
        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xs-6" style="padding-left:3rem">
          <button
            type="button"
            class="btn btn-info btn-fill btn-wd"
            @click.prevent="createTodo"
          >Save as To-do</button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Dialog } from "element-ui";
import moment from "moment";
import { vals, humanFileSize } from "../../../util";
import { Select, Option } from "element-ui";
import { TabulatorCard, EditLinksCard } from "src/components/index";
import api from "../../../axios_api";
import { mapGetters } from "vuex";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";

export default {
  name: "dialogmyinvestment",
  components: {
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
    [EditLinksCard.name]: EditLinksCard,
    TabulatorCard,
    VueBootstrapTypeahead
  },
  props: {
    value: {
      isShow: Boolean,
      data: Object
    },
    organization: "",
    investmentData: Object,
    contactEmail: String,
    lastFundingRoundDate: String
  },
  data() {
    return {
      vals,
      isSaving: false,
      investmentDisabled: true,
      files: [],
      emailString: "",
      downloadLink: "",
      company_name: "",
      referredResults: [],
      referred_by: "",
      investmentSubmit: false,
      edits: {
        docs: { add: [], delete: [], update: [], context: "fileupload" }
      }
    };
  },
  computed: {
    moment() {
      return moment;
    },
    isShow: {
      get() {
        return this.value.isShow;
      },
      set(value) {
        this.value.isShow = value;
        this.$emit("input", this.value);
      }
    },
    title: {
      get() {
        return this.value.isCreate
          ? "Add Your Investment"
          : "Edit Your Investment";
      }
    },

    isValidForm: function() {
      return (
        this.value.data.funding_round &&
        this.value.data.investment_amount > 0 &&
        this.value.data.ownership_percent > 0 &&
        this.value.data.investment_type
      );
    }
  },
  watch: {
    isShow: function(val) {
      if (val) {
        this.setUploadedFiles();
      }
    }
  },
  mounted() {
    let self = this;
    self.referred_by = "";
    this.$watch(
      () => {
        return this.referred_by;
      },
      searchReferredBy => {
        if (searchReferredBy) {
          this.getRefferedResults(searchReferredBy);
        }
      }
    );

    this.$watch(
      () => {
        if (!this.isCreate) {
          self.referred_by = self.value.data.referred_by
            ? self.value.data.referred_by.name
            : "";
          if (self.$refs.autocomplete) {
            self.$refs.autocomplete.inputValue = self.value.data.referred_by
              ? self.value.data.referred_by.name
              : "";
          }
          return self.value.data.referred_by
            ? self.value.data.referred_by.name
            : "";
        } else {
          return "";
        }
      },
      refer_name => {
        if (refer_name) {
          this.$refs.autocomplete.inputValue = refer_name;
        }
      }
    );
  },
  methods: {
    createTodo() {
      let data = {};
      data.status = "New";
      data.is_quick_task = false;
      data.task_type = "todo";
      data.urgency = 9;
      data.component = "portfolio";
      data.assigned_to = [this.$route.params.account_id];
      data.priority = "medium";
      data.workspace = this.$route.params.workspace_id;
      data.due_date = moment
        .utc(new Date().setDate(new Date().getDate() + 7))
        .format("YYYY-MM-DD");
      data.action_type = "email";
      data.description = `Send equity standing email to ${this.company_name}`;
      data.title = `Verify equity standing in ${this.company_name}`;
      console.log(data);
      api
        .post("/todo", {
          encrypt: {
            data: {
              todo: data
            }
          }
        })
        .then(resp => {
          this.$toaster.success("Saved successfully.");
          //this.$store.commit("todo/setTodoData", resp.data.encrypt.success[0]);
          this.$store.getters["todo/componentTodos"](
            "portfolio",
            this.$route.params.workspace_id
          );
          this.investmentSubmit = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleCancel() {
      this.isSaving = false;
      this.referred_by = "";
      this.files = [];
      this.isShow = false;
      if (this.$refs.autocomplete.inputValue) {
        this.$refs.autocomplete.inputValue = "";
      }
    },
    saveReferredBy(e) {
      this.referred_by = e.name;
      this.value.data.referred_by = {};
      this.value.data.referred_by._id = e._id;
      this.value.data.referred_by.name = e.name;
    },
    getRefferedResults(input) {
      let self = this;
      api
        .get(`/attributors/${self.$route.params.workspace_id}/${value}`)
        .then(data => {
          this.referredResults = data.data.encrypt.data;
        })
        .catch(err => {
          console.log("error", err);
        });
    },
    async handleDownload(item) {
      let self = this;

      let urlData = await api
        .post(`/file/download`, {
          encrypt: {
            data: {
              s3_path: item.id
            }
          }
        })
        .catch(e => {
          console.error("error: ", e);
        });

      if (
        urlData &&
        urlData.data &&
        urlData.data.encrypt &&
        urlData.data.encrypt.url
      ) {
        // window.open(urlData.data.encrypt.url);
        this.downloadLink = urlData.data.encrypt.url;

        setTimeout(() => {
          self.$refs.hiddenDownloadAnchor.click();
        });
      }
    },

    handleChange() {
      if (this.value.data.investment_amount < 0) {
        this.value.data.investment_amount = Math.abs(
          this.value.data.investment_amount
        );
      }
      if (this.value.data.ownership_percent < 0) {
        this.value.data.ownership_percent = Math.abs(
          this.value.data.ownership_percent
        );
      }
      if (this.value.data.equity < 0) {
        this.value.data.equity = Math.abs(this.value.data.equity);
      }
      if (this.value.data.equity > 100) this.value.data.equity = 100;
    },
    handleSave() {
      let self = this;
      this.isSaving = true;
      this.handleChange();
      this.value.data.organization = this.organization;
      this.value.data.is_lead_investor = !!this.value.data.is_lead_investor;
      this.value.data.is_prorata = !!this.value.data.is_prorata;
      this.value.data.investment_amount =
        this.value.data.investment_amount || 0;
      this.value.data.offering =
        this.value.data.offering && this.value.data.offering.funding_type
          ? this.value.data.offering.funding_type
          : this.value.data.offering;

      let promiseHandle;
      if (this.referred_by) {
        if (this.value.data && !this.value.data.hasOwnProperty("referred_by")) {
          this.value.data.referred_by = { _id: 0, name: this.referred_by };
        }
        if (
          this.value.data.hasOwnProperty("referred_by") &&
          this.value.data.referred_by.name != this.referred_by
        ) {
          this.value.data.referred_by = { _id: 0, name: this.referred_by };
        }
      } else {
        // if (!this.value.isCreate) {
        if (
          this.referred_by == "" &&
          this.value.data.hasOwnProperty("referred_by") &&
          this.value.data.referred_by._id &&
          this.value.data.referred_by.name
        ) {
          this.value.data.referred_by.name = "";
        }
        if (
          this.referred_by == "" &&
          this.value.data.hasOwnProperty("referred_by") &&
          this.value.data.referred_by._id == 0 &&
          this.value.data.referred_by.name
        ) {
          delete this.value.data.referred_by;
        }
        // }
      }

      if (this.value.isCreate) {
        self.company_name = this.value.data.company_name || "";
        promiseHandle = this.$store
          .dispatch("investment/createInvestment", this.value.data)
          .then(inserteddata => {
            //self.$emit("investment-save", {});
            self.referred_by = "";
            if (self.$refs.autocomplete.inputValue) {
              self.$refs.autocomplete.inputValue = "";
            }
            api
              .get(`/portfolio/investments/${self.value.data.portfolio_item}`)
              .then(data => {
                self.$emit("investment-save", data.data.encrypt.success);
                this.$toaster.success("Saved successfully.");
                if (self.contactEmail) {
                  let userName = self.$store.getters["user/user"];
                  let userNameString = `${userName.firstName} ${userName.lastName} `;
                  let subject = "Enquiry";
                  let fullyDilutedEquity = self.value.data.equity_standing
                    ? self.value.data.equity_standing
                    : "";
                  let amountInvested = self.value.data.amount
                    ? self.value.data.amount
                    : "";
                  let currentData;
                  let updateData =
                    "The current number of shares%0D%0AThe company's current valuation";
                  if (
                    fullyDilutedEquity ||
                    amountInvested ||
                    self.lastFundingRoundDate
                  ) {
                    currentData = `I currently show that:%0D%0A%0D%0A`;
                    if (fullyDilutedEquity) {
                      currentData += `Current Fully Diluted Equity: ${fullyDilutedEquity}%%0D%0A`;
                    } else {
                      updateData += "%0D%0AMy current fully diluted equity";
                    }
                    if (amountInvested) {
                      currentData += `Current Amount Invested: $${amountInvested} USD%0D%0A`;
                    } else {
                      updateData += "%0D%0AMy current amount invested";
                    }
                    if (self.lastFundingRoundDate) {
                      currentData += `Date of last round of Funding: ${self.lastFundingRoundDate}`;
                    } else {
                      updateData +=
                        "%0D%0AThe date of your last round of funding";
                    }
                    currentData += `%0D%0A%0D%0APlease correct any of the data above and update me to the below, if possible.%0D%0A%0D%0A`;
                  } else {
                    currentData =
                      "%0D%0A%0D%0APlease update me to the below, if possible.%0D%0A%0D%0A";
                    updateData +=
                      "%0D%0AMy current fully diluted equity%0D%0A%My current amount invested%0D%0A%The date of your last round of funding";
                  }
                  // let body = `Hi,%0D%0AI’m updating my files and was hoping to get my current standing with my investment in ${
                  //   self.company_name
                  // }.%0D%0A%0D%0A${currentData ||
                  //   ""} Please update the details below.%0D%0A%0D%0AMy current fully diluted equity%0D%0AThe current number of shares, if applicable.%0D%0AThe company's current valuation%0D%0AThe date of your last round of funding.%0D%0A%0D%0A Sincerely,%0D%0A${userNameString}`;
                  let body = `Hi we are reaching out on behalf of ${userNameString} to validate a bit of information.%0D%0A%0D%0Afiifi will only send emails when you have closed a new round of funding or something major has happened. This is great to keep my files up to speed and to be the most helpful to you.%0D%0A%0D%0AWould you be willing to share my current investment standing so I can update my files with ${self.company_name}?%0D%0A%0D%0A${currentData}${updateData}%0D%0A%0D%0AI will not bother you in the future with this info as you are a new investment I wanted to get this info to start things off.%0D%0A%0D%0ASincerely,%0D%0A${userNameString}`;
                  self.emailString = `mailto:${self.contactEmail}?subject=${subject}&body=${body}`;
                  self.investmentSubmit = true;
                }
                self.$store.dispatch("investment/start", null, { root: true });
                self.saveFiles(inserteddata);
              })
              .catch(err => console.log(err));
          });
      } else {
        let updateData = JSON.parse(JSON.stringify(this.value.data));
        let updateEquityStanding;
        if (
          this.investmentData.hasOwnProperty("equity_standing") &&
          this.investmentData.equity_standing.value
        ) {
          updateEquityStanding = JSON.parse(
            JSON.stringify(this.investmentData.equity_standing)
          );
          updateEquityStanding.value = this.value.data.equity_standing
            ? this.value.data.equity_standing
            : "";
        } else {
          if (this.value.data.equity_standing != "") {
            updateEquityStanding = {
              _id: 0,
              value: this.value.data.equity_standing
            };
          }
        }
        updateData.equity_standing = updateEquityStanding
          ? JSON.parse(JSON.stringify(updateEquityStanding))
          : "";
        if (updateData.equity_standing == "") {
          delete updateData.equity_standing;
        }
        promiseHandle = self.$store
          .dispatch("investment/updateInvestment", updateData)
          .then(data => {
            self.referred_by = "";
            if (self.$refs.autocomplete.inputValue) {
              self.$refs.autocomplete.inputValue = "";
            }
            api
              .get(`/portfolio/investments/${self.value.data.portfolio_item}`)
              .then(data => {
                this.$toaster.success("Saved successfully.");
                self.$emit("investment-save", data.data.encrypt.success);
                self.$store.dispatch("investment/start", null, { root: true });
                self.saveFiles(self.investmentData);
              })
              .catch(err => console.log(err));
          });
      }
      promiseHandle
        .then(val => {
          // this.$store.dispatch("investment/start", null, { root: true });
          // this.saveFiles(val || this.value.data);
        })
        .catch(err => {
          alert(err);
          console.log(err);
          this.isSaving = false;
        });
    },

    saveFiles(savedDoc) {
      let self = this;

      let filePayload = {
        files: [],
        data: []
      };
      _.forEach(self.edits.docs.add, item => {
        if (item.fileBlob || item.name || item.url) {
          filePayload.files.push(item.fileBlob || null);
          filePayload.data.push({
            _id: item._id,
            name: item.name,
            collection_name: item.collection_name || "investments",
            document_id: savedDoc._id,
            portfolio_item: self.value.data.portfolio_item,
            link_type: item.link_type,
            url: item.url
          });
        }
      });

      if (!filePayload.data.length) {
        this.updateFiles(savedDoc);
        return;
      }

      self.$store.dispatch("file/createFile", filePayload).then(
        item => {
          self.$store.dispatch("file/start", null, { root: true });
          self.updateFiles(savedDoc);
        },
        error => {
          this.isSaving = false;
        }
      );
    },

    updateFiles(savedDoc) {
      let self = this;

      self.isSaving = true;

      let filePayload = {
        data: []
      };
      _.forEach(self.edits.docs.update, item => {
        if (item._id && self.edits.docs.delete.indexOf(item._id) == -1) {
          filePayload.data.push({
            _id: item._id,
            name: item.name,
            collection_name: item.collection_name || "investments",
            document_id: savedDoc._id,
            link_type: item.link_type,
            url: item.url
          });
        }
      });

      if (!filePayload.data.length) {
        this.deleteFiles(savedDoc);
        return;
      }

      self.$store.dispatch("file/updateFile", filePayload.data).then(
        item => {
          self.$store.dispatch("file/start", null, { root: true });
          this.deleteFiles(savedDoc);
        },
        error => {
          this.isSaving = false;
        }
      );
    },

    deleteFiles(savedDoc) {
      let self = this;

      if (!self.edits.docs.delete.length) {
        this.isSaving = false;
        this.isShow = false;
        return;
      }

      self.isSaving = true;

      let delCounter = 0;
      _.forEach(self.edits.docs.delete, async item => {
        if (item) {
          let k = await self.$store.dispatch("file/deleteFile", item).then(
            item => {
              delCounter++;
              self.$store.dispatch("file/start", null, { root: true });
            },
            error => {
              delCounter++;
              this.isSaving = false;
            }
          );

          if (delCounter >= self.edits.docs.delete.length) {
            this.isShow = false;
          }
        }
      });
    },

    async setUploadedFiles() {
      this.edits = {
        docs: { add: [], delete: [], update: [], context: "fileupload" }
      };
      this.files = [];

      let uploadedDocs = [];
      if (!this.value.isCreate && this.value.data._id) {
        uploadedDocs = await this.$store.getters["file/filesByInvestmentId"](
          this.investmentData._id
        );
      }

      if (uploadedDocs.length) {
        this.files = uploadedDocs;
      }
    },

    linksAdd(context, data) {
      this.edits.docs.add.push(data.link);
    },
    linksDelete(context, data) {
      this.edits.docs.delete.push(data.id);
    },
    linksUpdated(context, data) {
      this.edits.docs.update = data.updated;
    },
    linksDownload(context, data) {
      this.handleDownload(data);
    },
    handleDelete(item, index) {
      this.files.splice(index, 1);

      if (item.document_id) {
        this.$store
          .dispatch("file/deleteFile", {
            id: item._id,
            collection_name: item.collection_name
          })
          .then(
            item => {
              this.$store.dispatch("file/start", null, { root: true });
            },
            error => {}
          );
      }
    }
  }
};
</script>

<style lang="scss">
.chb {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.edit-company-action-button-row {
  justify-content: center;
  margin-top: 20px;
}
.upload-list {
  min-height: 100%;
  overflow: auto;
  border: 2px dashed #bbb;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  padding: 25px;
  text-align: center;
  font: 20pt bold, "Vollkorn";
  color: #bbb;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.invisible {
  opacity: 0;
  position: absolute;
  top: 0;
  margin-top: -50000px;
  z-index: -2;
}
</style>